import './index.css';
import './libs/firebase';

import React from 'react';
import { createRoot } from 'react-dom/client';
import i18next from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles'
import { getSupportedLang } from '@alfred-systems/frontend-shared-components';
import App from './components/App';
import locales from './locales';

const userLanguage = getSupportedLang();

localStorage.removeItem('i18nextLng'); // clear any previously stored language preference

i18next.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: 'en',
  detection: {
    caches: []
  },
  resources: Object.keys(locales).reduce(
    (acc, lang) =>
      Object.assign(acc, { [lang]: { translation: locales[lang] } }),
    {}
  )
});

const fonts = {
  en: '"Open Sans", sans-serif',
  ja: '"Noto Sans JP", sans-serif',
  ko: '"Noto Sans KR", sans-serif'
};

const theme = createTheme({
  palette: {
    normal: {
      light: '#1a1a1a',
      main: '#1a1a1a',
      dark: '#1a1a1a',
      contrastText: '#fff',
    },
    white: {
      light: '#fff',
      main: '#fff',
      dark: '#fff',
      contrastText: '#1a1a1a',
    },
    primary: {
      light: '#fcc35d',
      main: '#fcc35d',
      dark: '#fcc35d',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7600',
      main: '#ff7600',
      dark: '#ff7600',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: fonts[userLanguage] || fonts['en'],
    caption: {
      fontSize: '0.75rem'
    },
    display1: {
      fontSize: '2.125rem'
    },
    subheading: {
      fontSize: '1rem'
    },
    title: {
      fontSize: '1.3125rem'
    },
    headline: {
      fontSize: '1.5rem'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  }
}); 

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <StylesProvider injectFirst={true}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StylesProvider>
  </React.StrictMode>
);
